import { useState } from 'react';
import constate from 'constate';
import config from '../../config';

const getFactSheetFiles = async (distributorId, planSponsorId, tickers) => {
  const url = new URL(`${config.pronvest.api.url}FactSheetFiles`);
  url.searchParams.set('distributorId', distributorId);
  url.searchParams.set('planSponsorId', planSponsorId);
  (tickers || []).forEach((ticker) => url.searchParams.append('tickers', ticker));

  const res = await fetch(url.toString(), {
    method: 'GET',
    headers: {
      Authorization: `ApiKey ${config.pronvest.api.apiKey}`,
    },
  });

  if (res.ok) {
    return res.json();
  }

  return [];
};

const Initialize = () => {
  const [factSheetFiles, setFactSheetFiles] = useState([]);
  const [uploadStatus, setUploadStatus] = useState('init');

  const loadFactSheetFiles = async (distributorId, planSponsorId, tickers) => {
    setFactSheetFiles(await getFactSheetFiles(distributorId, planSponsorId, tickers));
  };

  const uploadFactSheetFile = async (distributorId, ticker, planSponsorId, file) => {
    setUploadStatus('loading');
    const url = new URL(`${config.pronvest.api.url}FactSheetFiles`);
    const form = new FormData();
    form.append('DistributorId', distributorId);
    form.append('Ticker', ticker);
    form.append('PlanSponsorId', planSponsorId);
    form.append('File', file);

    try {
      const res = await fetch(url.toString(), {
        method: 'POST',
        headers: {
          Authorization: `ApiKey ${config.pronvest.api.apiKey}`,
        },
        body: form,
      });

      if (res.ok) {
        setUploadStatus('done');
        await loadFactSheetFiles(distributorId, planSponsorId);
        return true;
      }
    } catch (e) {
      // fall through to error status below
    }

    setUploadStatus('err');
    return false;
  };

  const deactivateFactSheetFile = async (factSheetFileId) => {
    const url = new URL(`${config.pronvest.api.url}FactSheetFiles/${factSheetFileId}`);

    const res = await fetch(url.toString(), {
      method: 'DELETE',
      headers: {
        Authorization: `ApiKey ${config.pronvest.api.apiKey}`,
      },
    });

    if (res.ok) {
      setFactSheetFiles((prev) =>
        prev.filter((f) => f.factSheetFileId !== factSheetFileId)
      );
      return true;
    }

    return false;
  };

  return {
    factSheetFiles,
    loadFactSheetFiles,
    uploadFactSheetFile,
    deactivateFactSheetFile,
    uploadStatus,
  };
};

const [FactSheetFilesProvider, useFactSheetFiles] = constate(Initialize);

export default FactSheetFilesProvider;
export { useFactSheetFiles, getFactSheetFiles };
